import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {Worker} from 'src/app/workers/shared/model/worker.model';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class WorkersResolver implements Resolve<Observable<Worker[]>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(): Observable<Worker[]> {
    return this.facadeService.getAllWorkers().pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
